<template>
  <div class="container-fluid pt-4 px-4">
    <v-card flat rounded="lg" class="buy-sell-card">
      <div class="data-table">
        <div class="table-responsive">
              <v-data-table
                :headers="this.grid.headers"
                :items="this.threadStockWise"
                :sort-by="[{ key: 'updated_at', order: 'desc' }]"
                :items-per-page-options= "[10, 15, 20, 30, 50, 100, 200]"
                :items-per-page="5"
                class="custom-data-table"
              >
              <template v-slot:top>
                  <v-toolbar
                    flat
                    class="buy-sell-toolbar"
                  >
                    <v-toolbar-title>Buy / Sell - Call</v-toolbar-title>
                    <v-divider
                      class="mx-4"
                      inset
                      vertical
                    ></v-divider>
                  </v-toolbar>
              </template>

              <template v-slot:[`item.current_price`]="{ item }">
                <CurrentPrice :row="item" :stockList="stocks"/>
              </template>

              <template v-slot:[`item.call_type`]="{ item }">
                <span v-if="item.call_type == 1">Buy</span>
                <span v-else-if="item.call_type == 2">Sell</span>
              </template>

              <template v-slot:[`item.status`]="{ item }">
                <span v-if="item.status == 1" @click="updatedInLine(item, {'status': 0})">Enable</span>
                <span v-else-if="item.status == 0" @click="updatedInLine(item, {'status': 1})">Disable</span>
              </template>

              <template v-slot:[`item.execute`]="{ item }">
                <font-awesome-icon
                  v-if="item.execute == 0"
                  :icon="['fas', 'check']"
                  class="execute-icon text-success"
                  @click="updatedInLine(item, {'execute': 1})"
                />
                <font-awesome-icon
                  v-else
                  :icon="['fas', 'minus']"
                  class="execute-icon text-muted"
                  @click="updatedInLine(item, {'execute': 0})"
                />
              </template>

              <template v-slot:[`item.updated_at`]="{ item }">
                <span><span>{{ this.$helper.formatDate(item.updated_at, true) }}</span></span>
              </template>

              </v-data-table>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>

import gql from 'graphql-tag';
import CurrentPrice from '@/views/tracker/buySell/CurrentPrice.vue';
import { useAlertStore } from '@/stores';

const THREAD_STOCK_WISE = gql`
query ThreadStockWise($allStock: Boolean) {
  threadStockWise(allStock: $allStock) {
    thread_id
    name
    type_id
    call_type
    qty
    rule
    status
    trigger_count
    execute
    created_at
    updated_at
  }
}`;

const STOCK_PRICE = gql`
query Stocks {
  stocks {
    stock_id
    code
    market_price
  }
}`

const UPDATE_THREAD_CELL = gql`
mutation UpdateThreadCell($threadId: ID!, $data: String!) {
  updateThreadCell(thread_id: $threadId, data: $data) {
    thread_id
  }
}`;

export default {
  name: "buy-sell",
  components: {
    CurrentPrice,
  },
  data: () => ({
    grid: {
      headers: [
        { title: 'Thread Id', key: 'thread_id' },
        { title: 'Name', key: 'name' },
        { title: 'Current Price', key: 'current_price' },
        { title: 'Buy/Sell', key: 'call_type' },
        { title: 'Qty', key: 'qty'},
        { title: 'Trigger', key: 'trigger_count'},
        { title: 'Status', key: 'status'},
        { title: 'Execute', key: 'execute'},
        { title: 'Updated At', key: 'updated_at' },
      ],
    },
    threadStockWise: [],
    stocks: [],
    dialogExecute: false,
  }),
  setup() {
    return {
        alertStore$: useAlertStore(),
    };
  }, 
  methods: { 
      async updatedInLine (item, data) {
        await this.$apollo.mutate({
                mutation: UPDATE_THREAD_CELL,
                variables: {
                    "threadId": item.thread_id,
                    "data": JSON.stringify(data)
                },
            }).then(() => {
                this.alertStore$.success('The thread has been update successfully.');
                this.$apollo.queries.threadStockWise.refetch();
            }).catch((error) => {
                this.alertStore$.error(JSON.stringify(error.message));
            });
      },
  },
  apollo: {
      threadStockWise:{
        query:THREAD_STOCK_WISE,
        variables () {
          return {
            allStock: false
          }
        },
      },
      stocks:{
        query:STOCK_PRICE,
      },
  },
};
</script>

<style scoped>
.execute-icon {
  cursor: pointer;
}

.buy-sell-card {
  border: 1px solid var(--border);
}

.buy-sell-toolbar {
  border-bottom: 1px solid var(--border);
}

.custom-data-table :deep(thead th) {
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-muted);
  background-color: #fafafa;
  border-bottom: 1px solid var(--border) !important;
}

.custom-data-table :deep(tbody tr) {
  transition: background-color 0.15s ease;
}

.custom-data-table :deep(tbody tr:hover) {
  background-color: #f8f9fb;
}

.custom-data-table :deep(tbody td) {
  font-size: 0.875rem;
  border-bottom: 1px solid #f1f2f4 !important;
}
</style>
